import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EventsState } from '../../../../../../store/types';
import { getPrivacyPolicy, createPrivacyPolicy, updatePrivacyPolicy, clearPrivacyPolicy } from '../../../../../../store/actions/admin/privacy-policy';
import './privacy-policy.scss';
import WaitingIndicator from '../../../../../general-ui/waiting-indicator/waiting-indicator';
import { ColorKeys, TextOverrides } from '../../../../../../types/working-model';
import { cannedPrivacyPolicy } from './cannedPrivacyPolicy';
import EditableTextDraft from '../../../../../general-ui/editable-text/editable-text-draft';

interface Props {
	privacy_policy?: number | null;
	token: string | null;
	channel?: number;
	eventID?: string;
}

export default function PrivacyPolicy({ privacy_policy, token, channel, eventID }: Props): JSX.Element {
	const {
		CreateEventReducer: {
			privacyPolicy,
		},
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearPrivacyPolicy());
		if (privacy_policy) {
			dispatch(getPrivacyPolicy(privacy_policy));
		}
	}, [privacy_policy, token, dispatch]);

	function handleTextChange(text: string) {
		if (privacyPolicy) {
			const updatedPolicy = {
				...privacyPolicy,
				content: text,
			};
			dispatch(updatePrivacyPolicy(updatedPolicy, token!));
		} else {
			const newPolicy = {
				eventID: eventID!,
				channel: channel!,
				content: text,
			};
			dispatch(createPrivacyPolicy(newPolicy, token!));
		}
	}

	function handleOverrideChange(overrides: TextOverrides) {
		if (!privacyPolicy) return;

		const updatedPolicy = {
			...privacyPolicy,
			settings: {
				...privacyPolicy.settings,
				content: overrides,
			}
		};
		dispatch(updatePrivacyPolicy(updatedPolicy, token!));
	}

	const policy = privacy_policy === null ? cannedPrivacyPolicy : privacyPolicy?.content;
	const textOverrides = privacyPolicy?.settings?.content?.color;

	return (
		<div className="editor-main-border">
			{ policy ?
				<div className="privacy-policy editor">
					<EditableTextDraft value={policy} onChange={handleTextChange} colorOverride={textOverrides} onOverrideChange={handleOverrideChange} defaultColor={ColorKeys.bodyTextColor} />
				</div>
				: <WaitingIndicator />}
		</div>
	);
}
